import { render, staticRenderFns } from "./ConfigContent.vue?vue&type=template&id=40dd21e4&scoped=true&"
import script from "./ConfigContent.vue?vue&type=script&lang=js&"
export * from "./ConfigContent.vue?vue&type=script&lang=js&"
import style0 from "./ConfigContent.vue?vue&type=style&index=0&id=40dd21e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dd21e4",
  null
  
)

export default component.exports